import { OgpApiService } from './ogp-api-service';
import { ServiceAgreementsResponse } from './service-agreements.types';

export class ServiceAgreementsService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getServiceAgreementsForCompany = async () => {
    return await this.ogpApiService.get<ServiceAgreementsResponse[]>({
      path: 'service-agreements',
    });
  };
}
